import { EnumRichiestaModuloDTOStatoCompilazione } from '@framework/api-client/api/inquiries-compile/schemas/enumRichiestaModuloDTOStatoCompilazione.ts';
import { assertNever } from '@framework/engine/utils/assertNever.ts';
import { SubmissionModuleState } from './SubmissionModuleState.ts';

export function mapSubmissionModuleState(
  state: EnumRichiestaModuloDTOStatoCompilazione | null | undefined,
) {
  // Di default, se non c'è stato, siamo in compilazione
  if (!state) return SubmissionModuleState.Compilation;

  switch (state) {
    case EnumRichiestaModuloDTOStatoCompilazione.IN_COMPILAZIONE:
      return SubmissionModuleState.Compilation;
    case EnumRichiestaModuloDTOStatoCompilazione.IN_FIRMA:
      return SubmissionModuleState.Sign;
    case EnumRichiestaModuloDTOStatoCompilazione.COMPLETATO:
      return SubmissionModuleState.Completed;
    default:
      assertNever(state);
  }
}
